import React from "react";
import { MONTH_OPTIONS, daysInMonth } from "../../dataScienceOperations/primitives/monthDay";
import type { MonthDay } from "../../dataScienceOperations/types";
import Select from "../ReusableComponents/Select";

interface MonthDayPickerProps {
  value: MonthDay | null;
  onChange: (next: MonthDay | null) => void;
}

const MonthDayPicker: React.FC<MonthDayPickerProps> = ({ value, onChange }) => {
  const month = value?.month ?? "";
  const day = value?.day ?? "";

  const handleMonthChange = (raw: string) => {
    if (raw === "") {
      onChange(null);
      return;
    }
    const m = parseInt(raw, 10);
    const clampedDay = Math.min(value?.day ?? 1, daysInMonth(m));
    onChange({ month: m, day: clampedDay });
  };

  const handleDayChange = (raw: string) => {
    if (raw === "") {
      onChange(null);
      return;
    }
    const d = parseInt(raw, 10);
    const m = value?.month ?? 1;
    onChange({ month: m, day: d });
  };

  const dayCount = value?.month ? daysInMonth(value.month) : 31;

  return (
    <div className="flex gap-2">
      <Select
        value={month}
        onChange={(e) => handleMonthChange(e.target.value)}
        containerClassName="flex-1"
      >
        <option value="">— Month —</option>
        {MONTH_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
      <Select
        value={day}
        onChange={(e) => handleDayChange(e.target.value)}
        disabled={!value?.month}
        containerClassName="flex-1"
      >
        <option value="">— Day —</option>
        {Array.from({ length: dayCount }, (_, i) => i + 1).map((d) => (
          <option key={d} value={d}>
            {d}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default MonthDayPicker;
